import ReducersTooling from '../../../tooling/reducersTooling';

const initialState = {
  groupList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  calculationUnitList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  groupCalculationUnitsList: ReducersTooling.initialStates.getFetchTypeInitialStateListAssign(),
  calculationUnitGroupsList: ReducersTooling.initialStates.getFetchTypeInitialStateListAssign(),
  saveGroupCalculationUnit: ReducersTooling.initialStates.getFetchTypeInitialStateAssign(),
  saveCalculationUnitGroup: ReducersTooling.initialStates.getFetchTypeInitialStateAssign(),
  import: ReducersTooling.initialStates.getFetchTypeInitialState(),
  downloadImport: ReducersTooling.initialStates.getFetchTypeInitialState(),
  periodsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  periodId: null
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/assignGroupAdmin/initialState.js